import { formatUsdCurrency } from '../portal-usd-wallet/ledgerUtils';
function formatFeeLine(amount, rate) {
    if (rate != null && rate > 0) {
        return `${formatUsdCurrency(amount)} (${(rate * 100).toFixed(0)}%)`;
    }
    return formatUsdCurrency(amount);
}
function formatFeeItemLabel(item, netWithdrawalPayout) {
    const isNetwork = item.key === 'network' || String(item.label).toLowerCase().includes('network');
    if (netWithdrawalPayout && isNetwork) {
        return 'Network fee — Fixed';
    }
    if (netWithdrawalPayout && item.rate != null && item.rate > 0) {
        return `${item.label} — ${(item.rate * 100).toFixed(0)}%`;
    }
    return item.label;
}
function formatFeeItemValue(item, netWithdrawalPayout) {
    if (netWithdrawalPayout) {
        return formatUsdCurrency(item.amount);
    }
    return formatFeeLine(item.amount, item.rate);
}
/** Build display rows for itemized fees (gateway / system / network / total). */
export function buildFeeBreakdownMetaKvs(breakdown, options) {
    var _a;
    if (!((_a = breakdown === null || breakdown === void 0 ? void 0 : breakdown.items) === null || _a === void 0 ? void 0 : _a.length))
        return [];
    const netWithdrawalPayout = (options === null || options === void 0 ? void 0 : options.netWithdrawalPayout) === true;
    const lines = breakdown.items
        .filter((item) => item.amount > 0.0001)
        .map((item) => ({
        label: formatFeeItemLabel(item, netWithdrawalPayout),
        value: formatFeeItemValue(item, netWithdrawalPayout),
    }));
    if (lines.length > 1) {
        lines.push({
            label: 'Total fee',
            value: netWithdrawalPayout
                ? formatUsdCurrency(breakdown.totalFeeUsd)
                : formatFeeLine(breakdown.totalFeeUsd, breakdown.totalFeeRate),
        });
    }
    return lines;
}
/** Explains percentage vs fixed fees for net-fee withdrawal payouts. */
export function buildNetWithdrawalFeeNote(netPayoutUsd, breakdown) {
    const items = breakdown.items.filter((item) => item.amount > 0.0001);
    if (!items.length)
        return undefined;
    const percentageFees = items
        .filter((item) => item.rate != null && item.rate > 0)
        .reduce((sum, item) => sum + item.amount, 0);
    const fixedFees = items
        .filter((item) => item.rate == null || item.rate <= 0)
        .reduce((sum, item) => sum + item.amount, 0);
    const parts = [];
    if (percentageFees > 0.0001 && netPayoutUsd > 0) {
        const pct = (percentageFees / netPayoutUsd) * 100;
        parts.push(`Percentage fees equal ${pct.toFixed(0)}% of the requested amount (${formatUsdCurrency(percentageFees)}).`);
    }
    if (fixedFees > 0.0001) {
        parts.push(`The additional ${formatUsdCurrency(fixedFees)} is a fixed network fee.`);
    }
    return parts.length ? parts.join(' ') : undefined;
}
/** Fallback when API did not send feeBreakdown (gross/net delta only). */
export function buildSingleFeeMetaKv(grossAmount, feeAmount) {
    const feeRate = grossAmount > 0 ? feeAmount / grossAmount : 0;
    return {
        label: 'Platform fee',
        value: formatFeeLine(feeAmount, feeRate > 0 ? feeRate : null),
    };
}
